(ns com.theplantscape.web-ui.tailwind.form.elements.input
  (:require [reagent.core :as r]))

(defn ui-form-submit [{:keys [label disabled]}]
  [:input.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-full.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center.inline-block
   {:type "submit"
    :disabled disabled #_(-> @form-state :disabled)
    :value label}])

(defn ui-form-input-fn [{:keys [get-value set-value name label placeholder tooltip] :as attrib}]
  (let [focused (r/atom false)]
    (fn [{:keys [name label placeholder tooltip] :as attrib}]
      [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       (if (and @focused tooltip)
         [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
          {:id (str "tooltip-" name) :role "tooltip"}
          [:div.tooltip-arrow tooltip]]
         [:label.font-semibold.text-sm.text-gray-600.pb-1 label])
       [:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:type "text"
         :default-value (get-value (keyword name))
         :value (get-value (keyword name))
         :placeholder placeholder
         :name name
         :on-focus #(reset! focused true)
         :on-blur #(reset! focused false)
         :on-change #(set-value (keyword name) %)}]])))

(defn ui-form-password-input-fn [{:keys [get-value set-value name label placeholder tooltip] :as attrib}]
  (let [focused (r/atom false)]
    (fn [{:keys [name label placeholder tooltip] :as attrib}]
      [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       (if (and @focused tooltip)
         [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
          {:id (str "tooltip-" name) :role "tooltip"}
          [:div.tooltip-arrow tooltip]]
         [:label.font-semibold.text-sm.text-gray-600.pb-1 label])
       [:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:type "password"
         :default-value (get-value (keyword name))
         :value (get-value (keyword name))
         :placeholder placeholder
         :name name
         :on-focus #(reset! focused true)
         :on-blur #(reset! focused false)
         :on-change #(set-value (keyword name) %)}]
       (if @focused
         (when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]]))])))

(defn ui-form-password-input [value-atom {:keys [name label placeholder tooltip] :as attrib}]
  (let [focused (r/atom false)]
    (fn [value-atom {:keys [name label placeholder tooltip] :as attrib}]
      [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       (if @focused
         (when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]])
         [:label.font-semibold.text-sm.text-gray-600.pb-1 label])
       [:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:type "text"
         :default-value @value-atom
         :value @value-atom
         :placeholder placeholder
         :name name
         :on-focus #(reset! focused true)
         :on-blur #(reset! focused false)
         :on-change (:store-fn attrib)}]
       (if @focused
         (when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]])
         [:label.font-semibold.text-sm.text-gray-600.pb-1 "Confirm " label])])))

(defn ui-form-password-confirm-input [value-atom {:keys [name label placeholder tooltip] :as attrib}]
  (let [errors (r/atom nil)
        focused (r/atom false)
        focused-confirm (r/atom false)
        compare-passwords (r/atom {})
        on-change (fn [e]
                    (prn (-> e .-target .-name))
                    (prn (keyword (-> e .-target .-name)))
                    (reset! errors nil)
                    (swap! compare-passwords assoc
                           (keyword (-> e .-target .-name))
                           (-> e .-target .-value))
                    (if (= (get @compare-passwords (keyword (str name)))
                           (get @compare-passwords (keyword (str name "-confirm"))))
                      (reset! value-atom (get @compare-passwords (keyword name)))
                      (reset! errors "Passwords do not match please correct.")))]

    (fn [value-atom {:keys [name label placeholder tooltip] :as attrib}]
      [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       [:div (str @errors)]
       (if (and tooltip @focused-confirm)
         [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
          {:id (str "tooltip-" name) :role "tooltip"}
          [:div.tooltip-arrow tooltip]]
         [:label.font-semibold.text-sm.text-gray-600.pb-1 label])
       [:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:type "password"
         :default-value (get @compare-passwords (keyword (str name)))
         :value (get @compare-passwords (keyword (str name)))
         :placeholder placeholder
         :name name
         :on-focus #(reset! focused true)
         :on-blur #(reset! focused false)
         :on-change on-change}]
       (if (and tooltip @focused-confirm)
         [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
          {:id (str "tooltip-confirm-" name) :role "tooltip"}
          [:div.tooltip-arrow tooltip]]
         [:label.font-semibold.text-sm.text-gray-600.pb-1 "Confirm " label])
       [:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:type "password"
         :default-value (get @compare-passwords (keyword (str name "-confirm")))
         :value (get @compare-passwords (keyword (str name "-confirm")))
         :placeholder placeholder
         :name (str name "-confirm")
         :on-focus #(reset! focused-confirm true)
         :on-blur #(reset! focused-confirm false)
         :on-change on-change}]])))

(defn ui-form-input [value-atom {:keys [name label placeholder tooltip] :as attrib}]
  (let [focused (r/atom false)]
    (fn [value-atom {:keys [name label placeholder tooltip] :as attrib}]
      [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       (if @focused
         (when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]])
         [:label.font-semibold.text-sm.text-gray-600.pb-1 label])
       [:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:type "text"
         :default-value @value-atom
         :value @value-atom
         :placeholder placeholder
         :name name
         :on-focus #(reset! focused true)
         :on-blur #(reset! focused false)
         :on-change (:store-fn attrib)}]])))

(defn ui-gps-coordinates [value-atom {:keys [name label placeholder tooltip get-location-fn] :as attrib}]
  [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
   [:label.font-semibold.text-sm.text-gray-600.pb-1 label]

   [:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
    {:type "text"
     :default-value (first @value-atom)
     :value (first @value-atom)
     :placeholder placeholder
     :name name
         ;:on-focus #(reset! focused true)
         ;:on-blur #(reset! focused false)
     :on-change (fn [e]
                  (.preventDefault e)
                  (reset! value-atom [(or (re-find #"[0-9.]*" (-> e .-target .-value ))  "")
                                      (or (second @value-atom) 0)])
                  #_(set-value e))}]
   [:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
    {:type "text"
     :default-value (second @value-atom)
     :value (second @value-atom)
     :placeholder placeholder
     :name name
         ;:on-focus #(reset! focused true)
         ;:on-blur #(reset! focused false)
     :on-change (fn [e]
                  (.preventDefault e)
                  ;(when (> (count (re-find #"[0-9.]*" (-> e .-target .-value ))) 0))
                  (reset! value-atom (vec [(or (first @value-atom) 0)
                                           (or (re-find #"[0-9.]*" (-> e .-target .-value ))  0)]))
                  #_(set-value e))}]
   [:button {:on-click (fn [e]
                         (.preventDefault e)
                         (prn "click")
                         (prn (get-location-fn))
                         (reset! value-atom (get-location-fn))
                         #_(reset! value-atom [50 80]))} "Set location from device"]])

(defn ui-gps-coordinates-fn [value-atom {:keys [name label placeholder tooltip] :as attrib}]
  [:div
   (str @value-atom)
   [ui-form-input-fn (merge {:get-value #(first value-atom)
                             :set-value #(vec [% (second value-atom)])} attrib)]
   [ui-form-input-fn (merge {:get-value #(second value-atom)
                             :set-value #(vec [(first value-atom) %])} attrib)]
   [:button {:on-click (fn [e] (prn "click")
                         (reset! value-atom [50 80]))} "Set location from device"]])
